import get from 'lodash/get'
import Event from './Event'

export default (
  eventName: Event,
  props: {
    page?: string
    component?: string
    [key: string]: any // extra props
  } = {}
) => {
  try {
    const track = get(window, 'analytics.track', (_name: string, _props: unknown) => null)
    track(eventName, { path: document.location.pathname, ...props })
  } catch (e) {
    //ignore error when not ready
  }
}
